import { RootAppState } from 'store/configureStore'

export const projectDefininedInPortalSelector = (state: RootAppState) =>
  state.project.activeProject?.definingInPortal
